import { Chip } from '@mui/material';

import { InfoIcon } from '@/components/StatusIcons';
import { InlineAlert, InlineAlertBody, InlineAlertTitle } from '@/components/ui/InlineAlert';
import theme from '@/theme';

export const SharedSpotterAlert = ({ unpermittedNoun }: { unpermittedNoun: string }) => {
    return (
        <InlineAlert severity="info" icon={<InfoIcon fontSize="inherit" />}>
            <InlineAlertTitle>This Spotter is owned by another account</InlineAlertTitle>
            <InlineAlertBody>
                You will not be able to make any changes to {unpermittedNoun} for this device. Please contact this
                Spotter&apos;s owner to make changes.
            </InlineAlertBody>
        </InlineAlert>
    );
};

export const SharedSpotterChip = () => {
    return (
        <Chip
            label="Shared Spotter"
            variant="filled"
            sx={{
                color: theme.palette.text.secondary,
            }}
        />
    );
};
